import { render, staticRenderFns } from "./DownloadRemoteDesktop.vue?vue&type=template&id=1b910039"
import script from "./DownloadRemoteDesktop.vue?vue&type=script&lang=js"
export * from "./DownloadRemoteDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports